import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wuxu",
  "use": "icon-wuxu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wuxu\"><path d=\"M341.333333 170.666667h554.666667v85.333333H341.333333V170.666667zM192 277.333333a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m0 298.666667a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m0 294.4a64 64 0 1 1 0-128 64 64 0 0 1 0 128zM341.333333 469.333333h554.666667v85.333334H341.333333v-85.333334z m0 298.666667h554.666667v85.333333H341.333333v-85.333333z\" p-id=\"3025\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol